import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormService, FieldsetComponent } from '@woolworthsnz/form';
import { ButtonState, ButtonComponent } from '@woolworthsnz/styleguide';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'dc-form-submit',
	templateUrl: './form-submit.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [FieldsetComponent, FormsModule, ReactiveFormsModule, ButtonComponent],
})
export class FormSubmitComponent implements OnInit, OnDestroy {
	@Input() label: string;

	@Input() group: FormGroup;
	buttonState = ButtonState.default;
	disabled = false;
	private destroyed$: Subject<boolean> = new Subject();

	constructor(private formService: FormService) {}

	ngOnInit(): void {
		this.formService.submitted$.pipe(takeUntil(this.destroyed$)).subscribe((s) => {
			this.buttonState = s ? ButtonState.busy : ButtonState.default;
		});
		this.formService.result$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
			this.buttonState = ButtonState.default;
			// if the form had a redirect url we go to it - otherwise display the message
		});
		this.formService.errored$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
			this.buttonState = ButtonState.errored;
		});
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
		this.destroyed$.complete();
	}

}
